import React, { useState } from 'react';
import { storage } from '../../../../services/StorageService';
import { buttonStyle, labelStyle, sectionHeaderStyle } from './styles';

interface CheatTogglesProps {
  onAction: (action: string, data?: any) => void;
}

export const CheatToggles: React.FC<CheatTogglesProps> = ({ onAction }) => {
  const [godMode, setGodMode] = useState(() => storage.getBoolean('helix_god_mode'));
  const [noclip, setNoclip] = useState(() => storage.getBoolean('helix_noclip'));

  const toggleGodMode = () => {
    const newVal = !godMode;
    storage.setBoolean('helix_god_mode', newVal);
    setGodMode(newVal);
    onAction('toggle_god_mode');
  };

  const toggleNoclip = () => {
    const newVal = !noclip;
    storage.setBoolean('helix_noclip', newVal);
    setNoclip(newVal);
    onAction('toggle_noclip');
  };

  return (
    <>
      <div style={sectionHeaderStyle}>Cheats</div>
      <button
        style={{
          ...buttonStyle,
          background: godMode ? '#f1c40f' : 'rgba(255,255,255,0.05)',
          color: godMode ? '#000' : '#ecf0f1'
        }}
        onClick={toggleGodMode}
      >
        💪 God Mode
      </button>
      <button
        style={{
          ...buttonStyle,
          background: noclip ? '#9b59b6' : 'rgba(255,255,255,0.05)'
        }}
        onClick={toggleNoclip}
      >
        👻 Noclip (Fly)
      </button>

      <div style={{ marginBottom: '10px' }}>
        <label style={labelStyle}>Speed Hack</label>
        <input
          type="range"
          min="1"
          max="5"
          step="0.5"
          defaultValue="1"
          style={{ width: '100%', cursor: 'pointer' }}
          onChange={(e) => onAction('set_speed_mult', Number(e.target.value))}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: '#666' }}>
          <span>1x</span>
          <span>5x</span>
        </div>
      </div>
    </>
  );
};
